module.exports = __webpack_public_path__ + "img/profile.658b1b48.png";